import { useState, useCallback } from 'react';
import type { ProcedureType } from '../../../../../../services/EncounterService/types/encounterTypes';

/**
 * Hook for managing service edit dialog state
 */
export function useServiceEditDialog(
  sortedProcedures: ProcedureType[],
  isEncounterCancelled: boolean
) {
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedProcedureId, setSelectedProcedureId] = useState<string | null>(null);

  // Get the current procedure from the sorted procedures
  const selectedProcedure = selectedProcedureId
    ? sortedProcedures.find((proc) => proc.id === selectedProcedureId) || null
    : null;

  const handleRowSelection = useCallback(
    (args: any) => {
      // Don't allow editing if encounter is cancelled
      if (isEncounterCancelled) {
        return;
      }

      if (args.data) {
        const procedure = sortedProcedures.find((proc) => proc.id === args.data.id);
        if (procedure) {
          setSelectedProcedureId(procedure.id!);
          setEditDialogOpen(true);
        }
      }
    },
    [sortedProcedures, isEncounterCancelled]
  );

  const handleClose = useCallback(() => {
    setEditDialogOpen(false);
    setSelectedProcedureId(null);
  }, []);

  return {
    editDialogOpen,
    selectedProcedure,
    handleRowSelection,
    handleClose,
  };
}
